import React, { PropsWithChildren } from 'react';
import { Dialog, DialogProps } from '@economic/taco';

type RoutedDialogProps = DialogProps & {
    onBeforeClose?: () => void;
    onClose: () => void;
};
const RoutedDialog = ({ children, onBeforeClose, onClose, ...props }: PropsWithChildren<RoutedDialogProps>) => (
    <Dialog
        defaultOpen
        onClose={() => {
            onBeforeClose?.();
            onClose();
        }}
        {...props}>
        {children}
    </Dialog>
);

export default RoutedDialog;
